import { ReactElement } from 'react';
import { QUERY_CLIENT } from '@mybonum/api';
import { getTheme } from '@mybonum/ui';
import { getCurrentSubdomain } from '@mybonum/utils';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { App as AntdApp, ConfigProvider } from 'antd';
import { ErrorBoundary } from 'react-error-boundary';
import { RouterProvider } from 'react-router';

import '@mybonum/ui/styles/global.scss';

import { ProfileProvider } from '@/contexts/profile';
import { ADMIN_ROUTER } from '@/services/router';
import { ErrorFallback } from '@/ui/error-fallback';

function App(): ReactElement {
    const { isFACCM } = getCurrentSubdomain();

    return (
        <ErrorBoundary FallbackComponent={(props) => <ErrorFallback {...props} />}>
            <AntdApp>
                <QueryClientProvider client={QUERY_CLIENT}>
                    <ConfigProvider theme={getTheme(isFACCM)}>
                        <ProfileProvider>
                            <RouterProvider router={ADMIN_ROUTER} />
                        </ProfileProvider>
                    </ConfigProvider>
                    <ReactQueryDevtools initialIsOpen={false} />
                </QueryClientProvider>
            </AntdApp>
        </ErrorBoundary>
    );
}

export default App;
